import React, { ReactElement } from 'react';

import { Portal } from '../../../../shared/Portal/Portal.component';
import { IActiveExperienceWinner } from '../useActiveExperienceWinners';

import { WinnersCarousel } from './WinnersCarousel';

type IWinnersProps = {
    winners: IActiveExperienceWinner[] | null;
};

export function Winners (props: IWinnersProps): ReactElement {
    const { winners }: IWinnersProps = props;

    return (
        <Portal el="active-experience-app__winner-carousel">
            <WinnersCarousel winners={winners || []} />
        </Portal>
    );
}
